import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Storage } from 'aws-amplify';
import { Button, CardActions, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import DefaultPhoto from '../../../../../assets/img/default-img.png';
import { MediaCard } from '../../../../../components';
import ShareEventButton from '../../../../../components/ShareEvent/ShareEventButton';
import ShareEventModal from '../../../../../components/ShareEvent/ShareEventModal';
import { useStorageImage } from '../../../../../hooks/useStorageImage';
// import './CardEvent.scss';
import './CardEvent.css';

function StatusCard() {
  return (
    <div className="status-event">
      <p className="status-event__label"> Canceled</p>
    </div>
  );
}
function UnlistedCard() {
  return (
    <div className="status-event">
      <p className="status-event__label"> Unlisted</p>
    </div>
  );
}
function CardEvent(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    image,
    title,
    caption,
    status,
    unlisted,
    eventDate,
    startEvent,
    description,
    cardFooter,
    eventId,
    children,
  } = props;
  const navigate = useNavigate();
  // const [imageUrl, setImageUrl] = useState(null);
  const photo = useStorageImage(image);

  const navigateToDetails = () => {
    navigate(`/app/event/${eventId}`);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <MediaCard image={photo || DefaultPhoto}>
      {!status && <StatusCard />}
      {unlisted && <UnlistedCard />}
      <CardContent>
        <Typography variant="h6" fontWeight="bold" component="div">
          {title}
        </Typography>
        <Typography gutterBottom variant="caption" color="text.secondary">
          {caption}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {eventDate}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {startEvent}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        {children}
      </CardContent>
      <CardActions>
        {cardFooter ?? (
          <>
            {/* <Button size="small" className="action-button">
              See
            </Button> */}
            <Button size="small" className="action-button" onClick={navigateToDetails}>
              Details
            </Button>
            <ShareEventButton onClick={handleOpenModal} />
            <ShareEventModal open={isModalOpen} handleClose={handleCloseModal} eventId={eventId} />
          </>
        )}
      </CardActions>
    </MediaCard>
  );
}

CardEvent.propTypes = {
  status: PropTypes.bool.isRequired,
  unlisted: PropTypes.bool,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  eventDate: PropTypes.string,
  startEvent: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cardFooter: PropTypes.node,
  eventId: PropTypes.number.isRequired,
  children: PropTypes.node,
};

CardEvent.defaultProps = {
  image: undefined,
  caption: undefined,
  unlisted: undefined,
  cardFooter: undefined,
  description: undefined,
  eventDate: undefined,
  startEvent: undefined,
  children: undefined,
};

export default CardEvent;
